module.exports = __webpack_public_path__ + "img/plus-minus.98634f96.svg";